module.exports = __webpack_public_path__ + "img/SMRT.3e4769ed.svg";